import Vue from 'vue'
import { cloneDeep } from 'lodash'

Object.defineProperty(Vue.prototype, '$cloneDeep', { value: cloneDeep })
